 // Leaf Custom Code - Start
(function () {

  // Guard: prevent double-execution if script is loaded more than once
  if (window._leafBundleEventsInit) return;
  window._leafBundleEventsInit = true;

  // Leaf Custom Code - Bundle Abandoned Check - Start
  (function () {
    var raw = sessionStorage.getItem('leafBundleAbandoned');
    if (!raw) return;
    sessionStorage.removeItem('leafBundleAbandoned');
    var data = {};
    try { data = JSON.parse(raw); } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'bundle_builder_abandoned',
      bundle: {
        slots_filled: data.slots_filled || 0,
        total_slots: data.total_slots || 0
      }
    });
    console.log('[DataLayer] bundle_abandoned fired on next page load', data);
  })();
  // Leaf Custom Code - Bundle Abandoned Check - Finish

  // Leaf Custom Code - Bundle Oil 1 Select - Start
  (function () {
    var container = document.getElementById('simple-bundles-options-container-new');
    if (!container) return;

    container.addEventListener('change', function (event) {
      var select = event.target;

      // Only fire for the first bundle dropdown slot
      if (select.tagName !== 'SELECT' || select.name !== 'items[1]') return;

      var selectedOption = select.selectedOptions[0];
      if (!selectedOption || !selectedOption.value) return;

      var itemName = selectedOption.text.trim();
      var itemId = selectedOption.value;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'bundle_builder_start',
        ecommerce: {
          item_list_id: 'misti_bundle',
          item_list_name: 'MISTI Bundle Oil Selection',
          items: [{
            item_name: itemName,
            item_id: itemId,
            index: 1,
            quantity: 1
          }]
        }
      });

      window._leafBundle = window._leafBundle || {};
      window._leafBundle.started = true;

      console.log('[DataLayer] bundle_builder_start (bundle oil 1) fired', itemName, itemId);
    });

  })();
  // Leaf Custom Code - Bundle Oil 1 Select - Finish

  // Leaf Custom Code - Bundle Oil Any Select - Start
  (function () {
    var container = document.getElementById('simple-bundles-options-container-new');
    if (!container) return;

    container.addEventListener('change', function (event) {
      var select = event.target;

      if (select.tagName !== 'SELECT') return;

      // Extract slot index from name attribute — e.g. "items[3]" → 3
      var indexMatch = select.name.match(/^items\[(\d+)\]$/);
      if (!indexMatch) return;
      var slotIndex = parseInt(indexMatch[1], 10);

      var selectedOption = select.selectedOptions[0];
      if (!selectedOption || !selectedOption.value) return;

      var itemName = selectedOption.text.trim();
      var itemId = selectedOption.value;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'select_item_bundle',
        ecommerce: {
          item_list_id: 'misti_bundle',
          item_list_name: 'MISTI Bundle Oil Selection',
          items: [{
            item_name: itemName,
            item_id: itemId,
            index: slotIndex,
            quantity: 1
          }]
        }
      });

      console.log('[DataLayer] select_item fired — slot', slotIndex, itemName, itemId);
    });

  })();
  // Leaf Custom Code - Bundle Oil Any Select - Finish

  // Leaf Custom Code - Bundle Add to Cart - Start
  (function () {
    var form = document.getElementById('atc');
    if (!form) return;

    form.addEventListener('submit', function () {
      var selects = document.querySelectorAll('#simple-bundles-options-container-new select.active');
      if (!selects.length) return;

      // Guard: all slots must have a value before firing
      var allFilled = Array.from(selects).every(function (s) { return s.value; });
      if (!allFilled) return;

      // Build one item per selected oil slot
      var items = Array.from(selects).map(function (select, idx) {
        var option = select.selectedOptions[0];
        return {
          item_name: option.text.trim(),
          item_id: option.value,
          index: idx + 1,
          item_list_id: 'misti_bundle',
          item_list_name: 'MISTI Bundle Oil Selection',
          quantity: 1
        };
      });

      // Read the bundle price from the active Alpine variant data
      var price = 0;
      try {
        var alpineEl = form.closest('[x-data]');
        if (alpineEl && window.Alpine) {
          price = Alpine.$data(alpineEl).product.selected.price / 100;
        }
      } catch (e) {}

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart_bundle',
        ecommerce: {
          currency: 'GBP',
          value: price,
          items: items
        }
      });

      window._leafBundle = window._leafBundle || {};
      window._leafBundle.completed = true;
      sessionStorage.removeItem('leafBundleAbandoned');

      console.log('[DataLayer] add_to_cart (bundle) fired', items, price);
    });

  })();
  // Leaf Custom Code - Bundle Add to Cart - Finish

  // Leaf Custom Code - Bundle Abandoned - Start
  (function () {
    var fired = false;

    function fireAbandon() {
      if (fired) return;
      if (!window._leafBundle || !window._leafBundle.started || window._leafBundle.completed) return;

      fired = true;

      // Count how many slots the user had filled when they left
      var selects = document.querySelectorAll('#simple-bundles-options-container-new select.active');
      var slotsFilled = Array.from(selects).filter(function (s) { return s.value; }).length;
      var totalSlots = selects.length;

      // sessionStorage survives same-tab navigation but is cleared on tab/browser close,
      // so this only fires when the user navigates away within the same tab.
      sessionStorage.setItem('leafBundleAbandoned', JSON.stringify({
        slots_filled: slotsFilled,
        total_slots: totalSlots
      }));

      console.log('[SessionStorage] bundle_abandoned saved — slots filled:', slotsFilled + '/' + totalSlots);
    }

    // pagehide covers navigation, tab close, and back/forward cache on all browsers
    window.addEventListener('pagehide', fireAbandon);

  })();
  // Leaf Custom Code - Bundle Abandoned - Finish

})();
 // Leaf Custom Code - Finish
